// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'question-circle',
  icon: [
    512,
    512,
    null,
    null,
    'M256 340a28 28 0 1 0 0 56 28 28 0 0 0 0-56zm7.67-24h-16a12 12 0 0 1-12-12v-.38c0-70.34 77.44-63.62 77.44-107.4 0-20.02-17.76-40.22-57.44-40.22-29.14 0-44.26 9.65-59.21 28.7-3.9 4.97-11.06 5.99-16.25 2.37l-13.13-9.15a11.98 11.98 0 0 1-2.65-17.18c21.23-27.23 46.41-44.74 91.24-44.74 52.32 0 97.44 29.75 97.44 80.21 0 67.42-77.44 63.85-77.44 107.4v.39a12 12 0 0 1-12 12zM256 40c118.62 0 216 96.08 216 216 0 119.3-96.61 216-216 216-119.24 0-216-96.56-216-216 0-119.2 96.6-216 216-216m0-32C119.04 8 8 119.08 8 256c0 137 111.04 248 248 248s248-111 248-248C504 119.08 392.96 8 256 8z',
  ],
})
